import http from './httpService';
import moment from 'moment-timezone';
/*global API */
const applicantsEndpoint = `${API}/api/Applicant`;

export function getApplicants(paramsTmp) {
  return http.get(applicantsEndpoint, {
    params: {
      TenantId: paramsTmp.TenantId,
      FirstName: paramsTmp.FirstName,
      LastName: paramsTmp.LastName,
      Type: paramsTmp.Type,
      Status: paramsTmp.Status,
      JobId: paramsTmp.JobId,
      Competence: paramsTmp.Competence,

      PageNumber: paramsTmp.PageNumber,
      PageSize: paramsTmp.PageSize,
      OnlyNew: paramsTmp.OnlyNew,
      MineOrAllSelected: paramsTmp.MineOrAllSelected,
      Lat: paramsTmp.Lat,
      Lng: paramsTmp.Lng,
      Distance: paramsTmp.DistanceFromCity.value,
    },
  });
}

export function getApplicant(id) {
  return http.get(applicantsEndpoint + '/getApplicant', {
    params: { applicantId: id },
  });
}

export function getApplicantsForSelect(searchString) {
  return http.get(applicantsEndpoint + '/applicantsForSelect', {
    params: {
      searchString: searchString,
    },
  });
}

export function getApplicantHistory(id) {
  return http.get(applicantsEndpoint + '/getApplicantHistory', {
    params: { applicantId: id },
  });
}

export function checkIfApplicantExists(email) {
  return http.get(applicantsEndpoint + '/checkIfApplicantExists', {
    params: { email },
  });
}

/** Currently backend only updates comments. */
export function updateApplicant(applicant) {
  return http.put(applicantsEndpoint, applicant);
}

export function addOrUpdateCommentToApplicant(commentDto) {
  return http.put(applicantsEndpoint + '/addOrUpdateCommentToApplicant', {
    Id: commentDto.commentId,
    Title: commentDto.commentTitle,
    Message: commentDto.commentMessage,
    Rating: commentDto.rating,
    ApplicantId: commentDto.applicantId,
  });
}

export function addCompetenceToApplicant(applicantCompetenceForCreationDto) {
  return http.put(applicantsEndpoint + '/addCompetenceToApplicant', applicantCompetenceForCreationDto);
}

export function updateApplicantStatus(applicantId, newStatus) {
  return http.put(applicantsEndpoint + '/updateApplicantStatus', {
    ApplicantId: applicantId,
    NewStatus: newStatus,
  });
}

export function getMostSuitableJobs(applicantId) {
  return http.get(applicantsEndpoint + '/mostSuitableJobs', {
    params: {
      applicantId,
    },
  });
}

export function setStarredApplicant(applicantId) {
  return http.put(applicantsEndpoint + '/setStarredApplicant', {
    applicantId,
  });
}

export function addApplicantToTenant(applicantId) {
  return http.put(applicantsEndpoint + '/addApplicantToTenant', {
    applicantId,
  });
}

export function deleteComment(commentId) {
  return http.delete(applicantsEndpoint + '/deleteComment', {
    params: {
      commentId,
    },
  });
}

export function deleteCompetenceFromApplicant(applicantCompetenceId) {
  return http.delete(applicantsEndpoint + '/deleteCompetenceFromApplicant', {
    params: {
      applicantCompetenceId,
    },
  });
}

export function getCommentsForApplicant(applicantId) {
  return http.get(applicantsEndpoint + '/getCommentsForApplicant', { params: { applicantId: applicantId } });
}

export function getCommentsForTenant() {
  return http.get(applicantsEndpoint + '/getCommentsForTenant');
}

export function assignUserToTheApplicant(applicantId, userId, alsoAssignApplications) {
  return http.put(applicantsEndpoint + '/assignUserToTheApplicant', {
    applicantId,
    userId,
    alsoAssignApplications,
  });
}

export function addRatingToApplicantsAnswer(rating, questionId, answerId, applicationId, fullScore, scoreId) {
  return http.put(applicantsEndpoint + '/addRatingToApplicantsAnswer', {
    rating,
    questionId,
    answerId,
    applicationId,
    fullScore,
    scoreId,
  });
}

export function createApplicantFromGitHubByRecruiter(applicant) {
  return http.post(applicantsEndpoint + '/createApplicantFromGitHubByRecruiter', applicant);
}

export function addDocumentToTheApplicant(documentWithApplicantId) {
  if (!documentWithApplicantId || !documentWithApplicantId.id || !documentWithApplicantId.document) {
    console.error('Missing applicant ID or document file.');
    return Promise.reject(new Error('Missing applicant ID or document file.'));
  }

  const formData = new FormData();
  formData.append('ApplicantId', documentWithApplicantId.id);
  formData.append('Document', documentWithApplicantId.document.file); // Note the capital D

  return http.post(`${applicantsEndpoint}/addDocumentToTheApplicant`, formData);
}

export function deleteDocumentFromTheApplicant(applicantId, documentId) {
  if (!applicantId || !documentId) {
    console.error('Missing params for the endpoint.');
    return Promise.reject(new Error('Missing params for the endpoint.'));
  }

  return http.delete(`${applicantsEndpoint}/deleteDocumentFromApplicant`, {
    params: {
      applicantId,
      documentId,
    },
  });
}

export function createOrUpdateApplicantByRecruiter(applicant) {
  const formData = new FormData();

  formData.append('address.city', applicant.cityControllerSelect.label);
  formData.append('address.countryCode', applicant.countryControllerSelect.value);
  formData.append('address.googlePlaceId', applicant.location.googlePlaceId);
  formData.append('address.lat', applicant.location.lat);
  formData.append('address.latForStreetSearch', 0);
  formData.append('address.lng', applicant.location.lng);
  formData.append('address.lngForStreetSearch', 0);
  formData.append('address.street', applicant.streetControllerSelect.label);

  formData.append('id', applicant.id ? applicant.id : 0);
  formData.append('firstName', applicant.firstName);
  formData.append('lastName', applicant.lastName);
  formData.append('email', applicant.email);
  formData.append('gender', applicant.gender);
  formData.append('linkedInUrl', applicant.linkedInUrl);
  formData.append('xUrl', applicant.xUrl);
  formData.append('facebookUrl', applicant.facebookUrl);
  formData.append('instagramUrl', applicant.instagramUrl);
  formData.append('personalWebsiteUrl', applicant.personalWebsiteUrl);
  formData.append('phoneNumber', applicant.phoneNumber);

  if (applicant.birthDate) {
    formData.append('dateOfBirth', moment(applicant.birthDate));
  }

  formData.append('introduction', applicant.introduction);

  applicant.cvFile?.file && formData.append('cvFile', applicant.cvFile.file);

  // In case user is changing the Photo, it must be in 'blob' form. Otherwise we already have it saved and it's just a url string
  if (applicant.profilePhoto) {
    if (applicant.profilePhoto.file) {
      formData.append('profilePhoto', applicant.profilePhoto.file);
    } else {
      // if sent oldPhotoUrl is null, the backend will delete it
      formData.append('oldProfilePhotoUrl', applicant.profilePhoto);
    }
  } else {
    // if sent oldPhotoUrl is null, the backend will delete it
    formData.append('oldProfilePhotoUrl', applicant.profilePhoto);
  }

  return http.post(applicantsEndpoint + '/createOrUpdateApplicantByRecruiter', formData);
}
